'use client';

import { useEffect, useState } from 'react';

interface CDNInfo {
	provider?: string;
	[key: string]: string | undefined;
}

// 存储 CDN 信息的全局变量
let cdnInfo: CDNInfo = {};

/**
 * Get CDN information from meta tag or window object
 */
export const getCDNInfo = (): CDNInfo => {
	return { ...cdnInfo };
};

/**
 * Provider to read and store CDN information from meta tag
 */
export const CDNInfoProvider = () => {
	const [isReady, setIsReady] = useState(false);

	useEffect(() => {
		// 从 meta tag 读取 CDN 信息
		const cdnInfoMeta = document.querySelector('meta[name="cdn-info"]');
		if (cdnInfoMeta) {
			try {
				const content = cdnInfoMeta.getAttribute('content');
				if (content) {
					const info = JSON.parse(content);
					cdnInfo = info;
					setIsReady(true);
				}
			} catch (error) {
				console.warn('Failed to parse CDN info:', error);
				setIsReady(true);
			}
		} else {
			// 如果没有 meta tag，尝试从 window.__CDN_INFO__ 读取（如果通过 script 注入）
			if (typeof window !== 'undefined') {
				const windowWithCDN = window as typeof window & { __CDN_INFO__?: CDNInfo };
				if (windowWithCDN.__CDN_INFO__) {
					try {
						cdnInfo = windowWithCDN.__CDN_INFO__;
						setIsReady(true);
					} catch (error) {
						console.warn('Failed to read CDN info from window:', error);
						setIsReady(true);
					}
				} else {
					setIsReady(true);
				}
			} else {
				setIsReady(true);
			}
		}
	}, []);

	return null;
};

